// =====================================
//
//   forgot business password Modal
//   Author: Gray
//   createtime: 2017 / 05 / 18
//
// =====================================

window.InifECApp.directive('forgotBusinessPassword', ['$rootScope', '$stateParams', '$timeout', '$ngModal', 'BusinessMemberService',
    function($rootScope, $stateParams, $timeout, $ngModal, BusinessMemberService) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            var openModal = function() {

                resetState();

                $ngModal.openModal('forgot-business-password-modal');
            }

            var closeModal = function() {

                $ngModal.closeModal('forgot-business-password-modal');
            }

            var forgotPassword = function(){
                
                if($scope.isSendding) {
                    return;
                }

                if(!$scope.form.email || !isEmail($scope.form.email)){
                    $scope.isEmailError = true;
                    return;
                }

                $scope.isMemberFreeze = false;
                $scope.isMemberNotExist = false;
                $scope.isSystemError = false;
                $scope.isSendding = true;

                BusinessMemberService.forgotPassword($scope.form.email).then(function(){
                    $scope.isSendding = false;
                    $scope.isSuccess = true;
                }, function(error){
                    $scope.isSendding = false;
                    if(error.code === 'error.formValidator.invalidMailFormat'){
                        $scope.isEmailError = true;
                    }else if(error.code === 'error.account.isFreeze'){
                        $scope.isMemberFreeze = true;
                    }else if(error.code === 'error.account.accountNotExist'){
                        $scope.isMemberNotExist = true;
                    }else{
                        $scope.isSystemError = true;
                    }
                });
            }

            var resetState = function() {

                $scope.form.email = '';
                $scope.isSendding = false;
                $scope.isEmailEmpty = false;
                $scope.isEmailError = false; // error.formValidator.invalidMailFormat
                $scope.isMemberFreeze = false; // error.account.isFreeze
                $scope.isMemberNotExist = false; // error.account.accountNotExist
                $scope.isSystemError = false;
                $scope.isSuccess = false;
            }

            var init = function() {

            }

            /*==========================
                Events
            ==========================*/
            $scope.$on("OPEN_FORGOT_BUSINESS_PASSWORD_MODAL", function(event, data) {

                openModal();
            });
                
            /*==========================
                Members
            ==========================*/

            $scope.form = {
                email: ''
            };
            $scope.isSendding = false;
            $scope.isEmailEmpty = false;
            $scope.isEmailError = false; // error.formValidator.invalidMailFormat
            $scope.isMemberFreeze = false; // error.account.isFreeze
            $scope.isMemberNotExist = false; // error.account.accountNotExist
            $scope.isSystemError = false;
            $scope.isSuccess = false;

            /*==========================
                Methods
            ==========================*/

            $scope.forgotPassword = forgotPassword;

            /*==========================
                init
            ==========================*/

            init();

        }]

        _dir.restrict = 'E';
        _dir.scope = true;
        _dir.templateUrl = 'partials/modal/forgot_business_password.html';
        _dir.controller = controller;

        return _dir;
}]);